var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRflogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 60,
    viewBox: "0 0 72 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 46",
    d: "M29.893 60a29.445 29.445 0 0 1-11.1-2.167 29.3 29.3 0 0 1-9.755-6.5l-.4-.4A29.5 29.5 0 0 1 .54 35.653a29.779 29.779 0 0 1 1.619-16.79 29.418 29.418 0 0 1 6.478-9.79l.4-.4A29.311 29.311 0 0 1 24.26.542a29.479 29.479 0 0 1 16.729 1.625 29.3 29.3 0 0 1 9.755 6.5L72 30 50.745 51.332a29.311 29.311 0 0 1-15.22 8.127 29.6 29.6 0 0 1-5.632.541zM16.1 28.268l3.818 5.859h10.369l6.078 10.506h10.276l-6.464-10.506h2.653a8.292 8.292 0 0 0 3.336-1.248c1.52-.991 3.327-2.976 3.308-6.8a8.206 8.206 0 0 0-3.336-7.007 8.722 8.722 0 0 0-3.308-1.455H9.157l3.816 5.856H40.8a2.229 2.229 0 0 1 .755.53 2.531 2.531 0 0 1 .514.8 3.268 3.268 0 0 1 .222 1.276 2.948 2.948 0 0 1-.244 1.211 1.775 1.775 0 0 1-.511.656 1.54 1.54 0 0 1-.735.321z",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRflogo);
export default __webpack_public_path__ + "static/media/rflogo.4d729e8fb29eb49a75b5eb65968fc94a.svg";
export { ForwardRef as ReactComponent };